import React from 'react';
import { IconProps } from 'react/types/icon';

const IconChevronRight = ({ width, height, color, ...rest }: IconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      fill="none"
      viewBox="0 0 24 24"
      {...rest}
    >
      <path
        fill={color || 'currentColor'}
        d="M9.63 17.252a.971.971 0 0 1 0-1.334L13.327 12 9.63 8.082a.971.971 0 0 1 1.413-1.334l4.059 4.3c.504.534.504 1.37 0 1.905l-4.059 4.299a.971.971 0 0 1-1.413 0Z"
      />
    </svg>
  );
};

export default IconChevronRight;
